require('../../modules/es6.array.find');
module.exports = require('../../modules/_core').Array.find;



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/fn/array/find.js
// module id = 213
// module chunks = 0